export default __webpack_public_path__ + "static/media/suwa_mobile.a06ef939.png";